var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,.5A24.5,24.5,0,1,0,49.5,25,24.5,24.5,0,0,0,25,.5Zm6.68,34a7.78,7.78,0,0,1-5.22,2.39v3.46h-2.9V36.86a7.59,7.59,0,0,1-7-6.61L21,29.08a3.89,3.89,0,0,0,4,3.79h.12a3.21,3.21,0,0,0,2.42-.82,2.78,2.78,0,0,0,.77-2,2.17,2.17,0,0,0-.77-1.8,14,14,0,0,0-3.44-1.55,19.71,19.71,0,0,1-3.74-1.63,6.14,6.14,0,0,1-2.17-2.27,6.63,6.63,0,0,1-.84-3.4,7.49,7.49,0,0,1,1.5-4.58,6.72,6.72,0,0,1,4.71-2.5V9.69h2.9v2.67a7,7,0,0,1,6.3,5.51l-4,1.63q-1.17-3.37-3.62-3.37a2.64,2.64,0,0,0-2,.75,2.54,2.54,0,0,0-.74,1.83,2,2,0,0,0,.72,1.68,12.44,12.44,0,0,0,3.06,1.45,27.15,27.15,0,0,1,4.06,1.78,6.28,6.28,0,0,1,2.34,2.32,6.62,6.62,0,0,1,.88,3.45A7.31,7.31,0,0,1,31.68,34.46Z",
    transform: "translate(-0.5 -0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.30017b4171f0b75ef807e60ad694b925.svg";
export { ForwardRef as ReactComponent };